module.exports = __webpack_public_path__ + "img/step4.da8c986a.png";